import(/* webpackMode: "eager" */ "/vercel/path0/node_modules/next/dist/client/image-component.js");
;
import(/* webpackMode: "eager", webpackExports: ["Footer"] */ "/vercel/path0/src/components/Home/LandingV6/blocks.jsx");
;
import(/* webpackMode: "eager" */ "/vercel/path0/src/components/Home/LandingV6/landing-v6.css");
;
import(/* webpackMode: "eager", webpackExports: ["Asterism","CornerPin","Squiggle","TapeSticker"] */ "/vercel/path0/src/components/Home/LandingV6/ornaments.jsx");
;
import(/* webpackMode: "eager", webpackExports: ["Nav","StartWritingButton"] */ "/vercel/path0/src/components/Home/LandingV6/ui.jsx");
